import React, { FC, useEffect } from 'react';
import { useSoftpayAppIdActions } from '../../context/SoftpayAppIdStore';

const SoftpayCallback: FC = () => {
  // get softpay app id from url param
  const urlParams = new URLSearchParams(window.location.search);
  const softpayAppId = urlParams.get('appId');
  const { setAppId } = useSoftpayAppIdActions();

  useEffect(() => {
    if (softpayAppId) {
      setAppId(softpayAppId);
      setTimeout(() => (window.location.href = '/'), 1000);
    }

    setTimeout(() => (window.location.href = '/'), 2000);
  }, [setAppId, softpayAppId]);

  if (softpayAppId) {
    return (
      <div>
        <h1>Softpay connected</h1>
        <p>App id: {softpayAppId}</p>
      </div>
    );
  }

  return (
    <div>
      <h1>Softpay connection failed</h1>
      {urlParams.toString()}
    </div>
  );
};

export default SoftpayCallback;
